import script from "./UIconButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIconButton.vue?vue&type=script&setup=true&lang=ts"

import "./UIconButton.vue?vue&type=style&index=0&id=27cc6abd&lang=css"

const __exports__ = script;

export default __exports__